// TODO: Use global variable to get current client/website
import { THEME_CONFIG } from "@Helpers/constHelper"

const dataFields: any = {
  [THEME_CONFIG.core.id]: {
    name: {
      label: "Nombre",
      input: "customerName",
      type: "text",
      order: 1,
    },
    direction: {
      label: "Dirección",
      input: "address",
      type: "text",
      order: 2,
    },
    commune: {
      label: "Comuna",
      input: "commune",
      type: "text",
      order: 3,
    },
    contactName: {
      label: "Recibe",
      input: "contactName",
      type: "text",
      order: 4,
    },
    reference: {
      label: "Observación",
      input: "reference",
      type: "text",
      order: 5,
    },
    contactPhone: {
      label: "Contacto",
      input: "contactPhone",
      type: "text",
      order: 6,
    },
    portability: {
      label: "Portabilidad",
      input: "portabilidad",
      type: "check",
      order: 7,
      forceShow: true,
      attrs: [
        {
          canEdit: false,
          id: "yes",
          label: "SI",
          name: "financed",
        },
        {
          canEdit: false,
          id: "No",
          label: "NO",
          name: "financed",
        },
      ],
      attrDefault: {
        name: "financed",
        default: "NO",
      },
    },
  },
  [THEME_CONFIG.privilege.id]: {
    storePickupId: {
      label: "Tienda que entrega",
      input: "storePickupId",
      type: "text",
      order: 1,
    },
    commune: {
      label: "Código de la Comuna",
      input: "commune",
      type: "text",
      order: 3,
    },
    communeName: {
      label: "Nombre de la comuna",
      input: "communeName",
      type: "text",
      order: 3,
    },
    portability: null,
  },
  [THEME_CONFIG.wom.id]: {
    recibeTercero: {
      label: "Recibe tercero",
      input: "recibeTercero",
      type: "text",
      order: 7,
      children: {
        contactCustomName: {
          label: "Nombre",
          input: "contactCustomName",
          type: "text",
          order: 7,
        },
        contactRut: {
          label: "RUT",
          input: "contactRut",
          type: "text",
          order: 8,
        },        
      },
    },
    contactPhone: {
      label: "Teléfono",
      input: "contactPhone",
      type: "text",
      order: 6,
    },
  },
}

export default dataFields
